"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("../Footer.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** Use the footer as meta navigation containing all navigation
items of the website and additionally any social links. */
function FooterLarge(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react.default.createElement("footer", {
    className: "Footer"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "container"
  }, children));
}

FooterLarge.propTypes = {
  /** @ignore */
  children: _propTypes.default.node
};
FooterLarge.defaultProps = {
  children: null
};
var _default = FooterLarge;
exports.default = _default;